/*
 * IMPORTS
 */
import { gql } from '@apollo/client'




/*
 * GRAPHS
 */

const Index = gql`
query CustomerAccountStatsReportQuery($customerAccountIds: [ID!], $country: String, $startDate: DateTime, $endDate: DateTime) {
  CustomerAccountStatsReport(customerAccountIds: $customerAccountIds, country: $country, startDate: $startDate, endDate: $endDate) {
    _reportData,
    id,
    message,
    status
  }
}
`


/*
 * EXPORTS
 */
export default Index
